/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import PropTypes from 'prop-types';

const cardCss =
  ({ fluid, modal }) =>
  (theme) =>
    [
      css`
        background-color: ${theme.color.white};
        border-radius: 3px;
      `,
      modal &&
        css`
          box-shadow: 0px 2px 16px 5px rgba(0, 0, 0, 0.72);
          max-height: 100vh;
          min-width: 400px;
          overflow: auto;
          @media ${theme.media.phone} {
            min-width: 300px;
          }
        `,
      modal &&
        !fluid &&
        css`
          @media ${theme.media.atLeastLaptop} {
            width: 560px;
          }
        `,
    ];

export const Card = ({ children, fluid, modal, ...rest }) => (
  <div {...rest} css={cardCss({ fluid, modal })}>
    {children}
  </div>
);

Card.propTypes = {
  children: PropTypes.node.isRequired,
  fluid: PropTypes.bool,
  modal: PropTypes.bool,
};
Card.defaultProps = {
  fluid: false,
  modal: false,
};
